import coreStore from "./core-store";

const remoteResource = 'cashflow/api/v1/generation-scripts';

const store = coreStore.createCoreStore('cashEventGenerationScript', remoteResource)

export default store;
